import { Component, OnInit, OnDestroy, ElementRef, Inject, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';

import { DirectionService } from '../../direction.service';
import { DialogService } from 'src/app/dialog/dialog.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from "@angular/common/http";

@Component({
  selector: 'app-resize',
  templateUrl: './resize.component.html',
  styleUrls: ['./resize.component.css'],
  host: {
    class: 'fill-screen-modal-resize'
  }
})
export class ResizeComponent implements OnInit, OnDestroy {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  isDarkMode: boolean = false;

  isLoading: boolean = false;

  paperWidth: number;
  currentFile: any;
  currentImageIndex: number;
  paperType: string;
  currentImage: any;
  imagePath: string;
  isMustResize: boolean;
  paperId: string;

  asumedDPI: number = 300;
  format: string;
  isVectoric: boolean = false;

  resizeNewFactor: number = 100;
  maxNewFactor: number = 400;
  maxNewFactorBigger: number = 400;
  originalrResizeNewFactor = 100;
  isBiggerMode: boolean = false;

  maxWidthLength: number = 0;
  maxHeightLength: number = 0;

  serverAddress: string = '';

  // @Output() onCloseResizeDialogEvent = new EventEmitter<void>();

  constructor(
    private directionService: DirectionService,
    private dialogService: DialogService,
    private elRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
  ) {
    this.paperWidth = data.paperWidth;
    this.currentFile = data.currentFile;
    this.currentImageIndex = data.currentImageIndex;
    this.paperType = data.paperType;
    this.currentImage = data.currentImage;
    this.imagePath = data.imagePath;
    this.isMustResize = data.isMustResize;
    this.serverAddress = data.serverAddress;
    this.paperId = data.paperId;
  }

  ngOnInit() {
    this.isLoading = false;
    this.directionSubscription = this.directionService.direction$.subscribe(direction => {
      this.isRTL = direction === 'rtl';
    });

    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });
    // set DPI if undefined
    if (this.currentImage.origImageDPI && this.currentImage.origImageDPI > 0) {
      this.asumedDPI = this.currentImage.origImageDPI;
    }

    // find format
    this.format = this.currentFile.fileName.split('.').pop();
    this.isVectoric = false;
    if (!(this.format === 'jpeg' || this.format === 'jpg' || this.format === 'png')) {
      this.isVectoric = true;
      this.asumedDPI = 300;
    }

    // calc maximum factor
    if (this.currentImage.origImageHeight < this.currentImage.origImageWidth) {
      // height is smaller
      const maxNewFactorSuggested = 100 * this.paperWidth / ((this.currentImage.origImageHeight / 300 * 2.54) + 0.25);
      if (maxNewFactorSuggested < 400) {
        if (!this.isMustResize) {
          // this.resizeNewFactor = this.roundDownOneDecimal((this.currentImage.imageWidth / this.currentImage.origImageWidth) * 100);
          this.maxNewFactor = this.roundDownOneDecimal(maxNewFactorSuggested);
          // console.log('********************** 111', this.resizeNewFactor);
        } else {
          // this.resizeNewFactor = this.roundDownOneDecimal(((this.paperWidth * 300 / 2.54) / this.currentImage.imageComHeight) * 100);
          this.maxNewFactor = this.roundDownOneDecimal(100 * this.paperWidth / ((this.currentImage.origImageHeight / 300 * 2.54) + 0.25));
          // console.log('********************** 222', this.resizeNewFactor);
        }
      } else {
        if (!this.isMustResize) {
          // this.resizeNewFactor = this.roundDownOneDecimal((this.currentImage.imageWidth / this.currentImage.origImageWidth) * 100);
          this.maxNewFactor = 400;
          this.maxNewFactorBigger = maxNewFactorSuggested < 800 ? maxNewFactorSuggested : 800;
          // console.log('********************** 333', this.resizeNewFactor);
        } else {
          // this.resizeNewFactor = this.roundDownOneDecimal(((this.paperWidth * 300 / 2.54) / this.currentImage.origImageWidth) * 100);
          this.maxNewFactor = this.roundDownOneDecimal(100 * this.paperWidth / ((this.currentImage.origImageHeight / 300 * 2.54) + 0.25));
          // console.log('********************** 444', this.resizeNewFactor);
        }
      }
    } else {
      // width is smaller
      const maxNewFactorSuggested = 100 * this.paperWidth / ((this.currentImage.origImageWidth / 300 * 2.54) + 0.25);
      if (maxNewFactorSuggested < 400) {
        if (!this.isMustResize) {
          // this.resizeNewFactor = this.roundDownOneDecimal((this.currentImage.imageHeight / this.currentImage.origImageHeight) * 100);
          this.maxNewFactor = this.roundDownOneDecimal(maxNewFactorSuggested);
          // console.log('********************** 555', this.resizeNewFactor);
        } else {
          // this.resizeNewFactor = this.roundDownOneDecimal(((this.paperWidth * 300 / 2.54) / this.currentImage.imageComWidth) * 100);
          this.maxNewFactor = this.roundDownOneDecimal(100 * this.paperWidth / ((this.currentImage.origImageWidth / 300 * 2.54) + 0.25));
          // console.log('********************** 666', this.resizeNewFactor);
        }
      } else {
        if (!this.isMustResize) {
          // this.resizeNewFactor = this.roundDownOneDecimal((this.currentImage.imageHeight / this.currentImage.origImageHeight) * 100);
          this.maxNewFactor = 400;
          this.maxNewFactorBigger = maxNewFactorSuggested < 800 ? maxNewFactorSuggested : 800;
          // console.log('********************** 777', this.resizeNewFactor);
        } else {
          // this.resizeNewFactor = this.roundDownOneDecimal(((this.paperWidth * 300 / 2.54) / this.currentImage.origImageHeight) * 100);
          this.maxNewFactor = this.roundDownOneDecimal(100 * this.paperWidth / ((this.currentImage.origImageWidth / 300 * 2.54) + 0.25));
          // console.log('********************** 888', this.resizeNewFactor);
        }
      }
    }

    const scale = this.currentFile.images[this.currentImageIndex].scale ? this.currentFile.images[this.currentImageIndex].scale : 1;
    const modifiedScale = this.roundDownOneDecimal(scale * 100);
    if (modifiedScale < this.maxNewFactor) {
      this.resizeNewFactor = modifiedScale;
    } else {
      this.resizeNewFactor = this.maxNewFactor;
      if (modifiedScale < this.maxNewFactorBigger) {
        this.isBiggerMode = true;
      }
    }
    // this.resizeNewFactor = this.roundDownOneDecimal(scale * 100) < this.maxNewFactor ? this.roundDownOneDecimal(scale * 100) : this.maxNewFactor;
    this.originalrResizeNewFactor = this.resizeNewFactor;

    this.setResizePreview();

    this.maxWidthLength = (this.maxNewFactor / 100) * (this.currentImage.origImageWidth / 300 * 2.54);
    this.maxHeightLength = (this.maxNewFactor / 100) * (this.currentImage.origImageHeight / 300 * 2.54);
  }

  async resizeImage() {
    if (!this.currentFile._id || !this.currentImage._id || !this.resizeNewFactor ||
      (this.resizeNewFactor === this.originalrResizeNewFactor && !this.isMustResize)) {
      this.closeResizeDialog();
      return;
    }
    this.isLoading = true;
    const newScale = this.resizeNewFactor < this.maxNewFactor ? this.resizeNewFactor : this.maxNewFactor;
    try {
      this.http.post(this.serverAddress + '/api/files/resize', {
        fileID: this.currentFile._id,
        imageID: this.currentImage._id,
        scale: this.roundDownOneDecimal(newScale) / 100,
        paperId: this.paperId,
      }).subscribe({
        next: (response) => {
          // Success handling
          // console.log('Success Resize:', response);
          this.closeResizeDialogSuccess();
          this.isLoading = false;
        },
        error: (error) => {
          // Failure handling
          this.isLoading = false;
          console.error('Error:', error);
        }
      });
    } catch (error) {
      console.error('Error:', error);
      this.isLoading = false
    }
  }

  closeResizeDialog() {
    this.dialogService.onCloseResizeDialog();
  }

  closeResizeDialogSuccess() {
    this.dialogService.onCloseResizeDialogSuccess();
  }

  roundDown(num: number): number {
    return Math.ceil(num);
  }

  roundDownOneDecimal(num: number): number {
    return Math.ceil(num * 10) / 10;
  }

  jumpPercent(percent: number) {
    this.resizeNewFactor = percent;
  }

  getUserName() {
    return localStorage.getItem('userName');
  }

  setResizePreview() {
    //  gradient
    const resizeSlider: HTMLElement = this.elRef.nativeElement.querySelector('.mdc-slider__track--active');
    const dpi = this.asumedDPI;
    resizeSlider.style.background = `linear-gradient(-90deg, var(--zx-green) 0%, var(--zx-green) ${(400 / this.maxNewFactor) * (140 / 400 * 100) * dpi / 300}%, var(--zx-orange) ${(400 / this.maxNewFactor) * (155 / 400 * 100) * dpi / 300}%, var(--zx-orange) ${(400 / this.maxNewFactor) * (240 / 400 * 100) * dpi / 300}%, var(--zx-red) ${(400 / this.maxNewFactor) * (255 / 400 * 100) * dpi / 300}%, var(--zx-red) 100%)`;

    // image
    const imageCom = this.elRef.nativeElement.querySelector('#zx-resize-image-com');
    const imageComWidth = imageCom.offsetWidth;
    const imageComHeight = imageCom.offsetHeight - 50;
    const realImageWidth = this.currentImage.origImageWidth;
    const realImageHeight = this.currentImage.origImageHeight;
    const image = this.elRef.nativeElement.querySelector('#zx-resize-image');
    const resizeInputConSide = this.elRef.nativeElement.querySelector('#zx-resize-input-con-side');
    const resizeInputConTop = this.elRef.nativeElement.querySelector('#zx-resize-input-con-top');
    if (imageComWidth / imageComHeight < realImageWidth / realImageHeight) {
      // height is bigger
      image.style.height = `${imageComHeight * (realImageHeight / realImageWidth) * (imageComWidth / imageComHeight)}px`;
      image.style.width = `${imageComWidth}px`;
      resizeInputConSide.style.height = `${imageComHeight * (realImageHeight / realImageWidth) * (imageComWidth / imageComHeight)}px`;
      resizeInputConTop.style.width = `${imageComWidth}px`;
    } else {
      // width is bigger
      image.style.height = `${imageComHeight}px`;
      image.style.width = `${imageComWidth * (realImageWidth / realImageHeight) * (imageComHeight / imageComWidth)}px`;
      resizeInputConSide.style.height = `${imageComHeight}px`;
      resizeInputConTop.style.width = `${imageComWidth * (realImageWidth / realImageHeight) * (imageComHeight / imageComWidth)}px`;
    }

    // move the nums
    const numbersCon = this.elRef.nativeElement.querySelector('#zx-numbers-con');
    const numbersConWidth = numbersCon.offsetWidth;

    const num1 = this.elRef.nativeElement.querySelector('#num-50');
    const num50 = this.elRef.nativeElement.querySelector('#num-50');
    const num100 = this.elRef.nativeElement.querySelector('#num-100');
    const num150 = this.elRef.nativeElement.querySelector('#num-150');
    const num200 = this.elRef.nativeElement.querySelector('#num-200');
    const num250 = this.elRef.nativeElement.querySelector('#num-250');
    const num300 = this.elRef.nativeElement.querySelector('#num-300');
    const num350 = this.elRef.nativeElement.querySelector('#num-350');
    const num400 = this.elRef.nativeElement.querySelector('#num-400');

    const moveValue = (numbersConWidth / 8) * ((400 / this.maxNewFactor) - 1);

    const num1Width = num1.offsetWidth;
    const num50Width = num50.offsetWidth;
    const num100Width = num100.offsetWidth;
    const num150Width = num150.offsetWidth;
    const num200Width = num200.offsetWidth;
    const num250Width = num250.offsetWidth;
    const num300Width = num300.offsetWidth;
    const num350Width = num350.offsetWidth;
    const num400Width = num400.offsetWidth;

    num1.style.transform = `translateX(-${0 - (num1Width / 2)}px)`;
    num50.style.transform = `translateX(-${moveValue - (num50Width / 2)}px)`;
    num100.style.transform = `translateX(-${(moveValue * 2) - (num100Width / 2)}px)`;
    num150.style.transform = `translateX(-${(moveValue * 3) - (num150Width / 2)}px)`;
    num200.style.transform = `translateX(-${(moveValue * 4) - (num200Width / 2)}px)`;
    num250.style.transform = `translateX(-${(moveValue * 5) - (num250Width / 2)}px)`;
    num300.style.transform = `translateX(-${(moveValue * 6) - (num300Width / 2)}px)`;
    num350.style.transform = `translateX(-${(moveValue * 7) - (num350Width / 2)}px`;
    num400.style.transform = `translateX(-${(moveValue * 8) - (num400Width / 2)}px`;
  }

  // roundResizeNewFactor
  // get
  get roundResizeNewFactor() {
    if (this.resizeNewFactor < this.maxNewFactor) {
      return this.roundDownOneDecimal(this.resizeNewFactor);
    } else {
      return this.roundDownOneDecimal(this.maxNewFactor);
    }
  }
  // set
  set roundResizeNewFactor(value: number) {
    const newValue = this.roundDownOneDecimal(value);
    this.resizeNewFactor = newValue > this.maxNewFactor ? this.maxNewFactor : newValue;
  }

  // calculatedHeightValue
  // get
  get calculatedHeightValue() {
    if (this.resizeNewFactor < this.maxNewFactor) {
      return this.roundDownOneDecimal(this.resizeNewFactor * this.currentImage.origImageHeight / 300 * 2.54 / 100);
    } else {
      return this.roundDownOneDecimal(this.maxNewFactor * this.currentImage.origImageHeight / 300 * 2.54 / 100);
    }
  }
  // set
  set calculatedHeightValue(value: number) {
    const newValue = this.roundDownOneDecimal(value / this.currentImage.origImageHeight * 300 / 2.54 * 100);
    this.resizeNewFactor = newValue > this.maxNewFactor ? this.maxNewFactor : newValue;
    if (value > this.calculatedHeightValue) {
      this.forceBindingUpdate();
    }
  }

  // calculatedWidthValue
  // get
  get calculatedWidthValue() {
    if (this.resizeNewFactor < this.maxNewFactor) {
      return this.roundDownOneDecimal(this.resizeNewFactor * this.currentImage.origImageWidth / 300 * 2.54 / 100);
    } else {
      return this.roundDownOneDecimal(this.maxNewFactor * this.currentImage.origImageWidth / 300 * 2.54 / 100);
    }
  }
  // set
  set calculatedWidthValue(value: number) {
    const newValue = this.roundDownOneDecimal(value / this.currentImage.origImageWidth * 300 / 2.54 * 100);
    this.resizeNewFactor = newValue > this.maxNewFactor ? this.maxNewFactor : newValue;
    if (value > this.calculatedWidthValue) {
      this.forceBindingUpdate();
    }
  }

  private forceBindingUpdate() {
    const tempFactor = this.resizeNewFactor;
    this.resizeNewFactor = null;
    setTimeout(() => {
      this.resizeNewFactor = tempFactor;
    });
  }

  scaleByMax(value: number) {
    return this.roundDown(value * (this.maxNewFactor / 400));
  }

  onWidthBlur(event: any) {
    this.calculatedWidthValue = parseFloat((event.target as HTMLInputElement).value);
  }

  onHeightBlur(event: any) {
    this.calculatedHeightValue = parseFloat((event.target as HTMLInputElement).value);
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
  }

  // Bigger Mode
  turnOnBiggerMode() {
    this.isBiggerMode = true;
  }

  turnOffBiggerMode() {
    this.isBiggerMode = false;
  }

  // Get display file name after split('-')[1] - returns originalFileName if exists, otherwise uses fileName.split('-')[1]
  getDisplayFileNameAfterSplit(file: any): string {
    if (!file) {
      return '';
    }
    // If originalFileName exists, return it as is (assuming it's already the clean name)
    if (file.originalFileName && file.originalFileName.trim() !== '') {
      return file.originalFileName;
    }
    // For fileName, use the existing split logic
    if (!file.fileName) {
      return '';
    }
    const parts = file.fileName.split('-');
    return parts.length > 1 ? parts[1] : file.fileName;
  }
}
